export const media_with_details = `{
    url
    alt
    media {
      type
      information
    }
  }`